import { render, staticRenderFns } from "./ClipboardComposer.vue?vue&type=template&id=acc74f9a&scoped=true"
import script from "./ClipboardComposer.vue?vue&type=script&lang=js"
export * from "./ClipboardComposer.vue?vue&type=script&lang=js"
import style0 from "./ClipboardComposer.vue?vue&type=style&index=0&id=acc74f9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc74f9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acc74f9a')) {
      api.createRecord('acc74f9a', component.options)
    } else {
      api.reload('acc74f9a', component.options)
    }
    module.hot.accept("./ClipboardComposer.vue?vue&type=template&id=acc74f9a&scoped=true", function () {
      api.rerender('acc74f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/clipboard/ClipboardComposer.vue"
export default component.exports